export const typesCounter = {
    createUserCounter: '[user] create_user_counter',
    getUserCounter: '[user] get_user_counter',
    deleteUserCounter: '[user] delete_user_counter',
    updateUserCounter: '[user] update_user_counter',
    getCoursesCounter: '[courses] getCoursesCounter',
}
